/**
 * @copyright Copyright (c) 2024
 * @license AGPL-3.0
 */

export default {
  name: 'EpubViewer',
  
  render: function(h) {
    return h('div', { 
      class: 'epubviewer-container',
    }, [
      h('div', { 
        class: 'epub-viewer',
        ref: 'viewerContainer' 
      }),
      this.loading ? h('div', { 
        class: 'epubviewer-loader' 
      }, [
        h('span', { 
          class: 'icon-loading' 
        })
      ]) : null
    ])
  },
  
  props: {
    source: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      required: true
    },
    permissions: {
      type: String,
      required: true
    },
    fileVersion: {
      type: Number,
      default: null
    },
    basename: {
      type: String,
      default: null
    }
  },
  
  data() {
    return {
      loading: true,
      book: null,
      rendition: null
    }
  },
  
  mounted() {
    this.loadEpub()
  },
  
  beforeDestroy() {
    if (this.rendition && this.rendition.destroy) {
      this.rendition.destroy()
    }
  },
  
  methods: {
    async loadEpub() {
      try {
        // Dynamically import epub.js when needed
        const ePub = await import('epubjs')
        
        // Create new book
        this.book = ePub.default(this.source)
        
        // Initialize the rendition
        this.rendition = this.book.renderTo(this.$refs.viewerContainer, {
          width: '100%',
          height: '100%',
          spread: 'auto'
        })

        // Load and display
        await this.rendition.display()

        // Add keyboard navigation
        this.setupKeyboardControls()

        this.loading = false
        this.$emit('update:loaded', true)
      } catch (error) {
        console.error('Error loading EPUB:', error)
        this.loading = false
        this.$emit('update:loaded', true)
      }
    },
    
    setupKeyboardControls() {
      window.addEventListener('keyup', (e) => {
        if (!this.rendition) return

        // Arrow Left: Previous page
        if ((e.keyCode || e.which) === 37) {
          this.rendition.prev()
        }
        // Arrow Right: Next page
        if ((e.keyCode || e.which) === 39) {
          this.rendition.next()
        }
      })
    }
  }
} 